
import React, { Component } from 'react';
// import LoaderGIF from '../../assets/images/loader.gif';
import { Styles } from "./styles/fullPageLoader.js";
import { connect } from "react-redux";

class FullPageLoader extends Component {
    state = {};


    render() {
        const {loading} = this.props;

        if (!loading) {
            return null;
        }
        return (
            <Styles>
                <div className="loader-container">
                    <div className="loader">
                        <img src="../../assets/images/loader.gif" alt="Loading..."></img>
                    </div>
                </div>
            </Styles>
        )
    }
}

const mapStateToProps = state => ({loading: state.allProducts.loading})

export default connect(mapStateToProps)(FullPageLoader);